var tab = document.getElementsByClassName("tab-link");
var i;

for (i = 0; i < tab.length; i++) {
  
  tab[i].addEventListener("click", function() {
    
    document.querySelectorAll(".tab-link").forEach(x=>x.classList.remove('active'));
    document.querySelectorAll(".tab-content").forEach(x=>x.classList.remove('open'));
    
    this.classList.toggle("active");
    var tabid = this.id;
    tabid += '-content';
    
    var tabcontent = document.getElementById(tabid);
    tabcontent.classList.add('open');

    
  });
}
